import { render } from "./SidenavItem.vue?vue&type=template&id=cef65548&scoped=true"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=cef65548&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef65548"]])

export default __exports__